<template>
    <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    {{ translate('draft.mergePdf') }}
                </div>
                <div class="modal-body">
                    <div class="col">
                        <file-upload style="display:none" ref="pdfUpload" name="Documents" accept="application/pdf"
                            input-id="pdfDocumentUpload" v-model="files"
                            :post-action="axios.defaults.baseURL + '/pdfmergeAttachment/AddPdfMergeChunk/' + data.Id + '?draftId='+Id" :multiple="true" :drop="false"
                            :thread="1" @input="$refs.pdfUpload.active = true" chunk-enabled :chunk="{
                                headers: {
                                    token: axios.defaults.headers.common['token'],
                                },
                                action: axios.defaults.baseURL + '/pdfmergeAttachment/AddPdfMergeChunk/' + data.Id + '?draftId='+Id,
                                //minSize: 1048576,
                                minSize: 0,
                                maxActive: 3,
                                maxRetries: 3,

                                // Example in the case your backend also needs the user id to operate
                                startBody: {
                                    //user_id: user.id
                                },
                            }">
                        </file-upload>
                        <div class="form-control" style="padding: 0; margin-bottom:1rem; height:auto;">
                            <table v-if="data.Documents && data.Documents.length"
                                class="table table-striped table-hover table-borderless" style="margin-bottom:0">
                                <tbody>
                                    <draggable v-model="data.Documents" @start="drag = true" @end="drag = false"
                                        ghost-class="ghost">
                                        <template>
                                            <div class="documentContainer" v-for="(i,index) in data.Documents" :key="index">
                                                <div class="documentInner">
                                                    <div class="remove" @click="removeDocument(i)"><span style="visibility: hidden;">x</span></div>
                                                    <div>{{ i.FileName }}</div>
                                                </div>
                                                <div class="documentRight">
                                                    <div>{{ i.Size | prettyBytes }}</div>
                                                    <div class="moveIconContainer">
                                                        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px"
                                                            viewBox="0 0 25 25" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                                d="M9.5 8C10.3284 8 11 7.32843 11 6.5C11 5.67157 10.3284 5 9.5 5C8.67157 5 8 5.67157 8 6.5C8 7.32843 8.67157 8 9.5 8ZM9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14ZM11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5ZM15.5 8C16.3284 8 17 7.32843 17 6.5C17 5.67157 16.3284 5 15.5 5C14.6716 5 14 5.67157 14 6.5C14 7.32843 14.6716 8 15.5 8ZM17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"
                                                                fill="#121923" />
                                                        </svg> -->
                                                        <div v-show="index !== 0" class="p-1 border border-1" @click="moveDocumentUp(index)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                                                                <path d="M12 17L12 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M16 11L12 7L8 11" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                            </svg>
                                                        </div>
                                                        <div v-show="index !== data.Documents.length - 1" class="p-1 border border-1" @click="moveDocumentDown(index)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                                                                <path d="M12 7L12 16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M8 13L12 17L16 13" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </draggable>
                                </tbody>
                            </table>
                            <label v-else class="text-muted text-center"
                                style="padding:40px; display:block; cursor:pointer;" for="pdfDocumentUpload">
                                {{ translate('draft.addPdfToMerge') }}
                            </label>
                        </div>
                        <div class="row">
                            <div class="col text-right">
                                <label for="pdfDocumentUpload" class="btn btn-outline-secondary btn-sm"
                                    :title="translate('draft.addPdfToMerge')">
                                    <icon-plus />
                                    {{ translate('draft.addFile') }}
                                </label>
                            </div>
                        </div>
                        <div class="clear-fix"></div>
                        <div>
                            <div v-for="file in files" :key="file.id" v-show="file.active || !file.Success"
                                style="padding: 10px 0">
                                <div>
                                    {{ file.name }}
                                    <small class="text-muted">{{ file.size | prettyBytes }}</small>
                                </div>
                                <div class="progress" v-if="file.active">
                                    <div class="progress-bar progress-bar-striped progress-bar-animated text-left"
                                        role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                                        :style="{ width: file.progress + '%' }">
                                        &nbsp;%{{ parseInt(file.progress, 10) }}
                                    </div>
                                </div>
                                <div class="text-danger" style="font-size:0.8rem" v-if="file.error">
                                    <div v-for="ms in file.response.ModelState" :key="ms">
                                        <div v-for="err in ms" :key="err">{{ err }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-right">
                                <label v-show="$refs.pdfUpload && $refs.pdfUpload.active"
                                    @click.prevent="$refs.pdfUpload.active = false" class="btn btn-primary btn-sm"
                                    type="button">
                                    {{ translate('draft.stopUpload') }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer footer-button-container">
                    <button @click="$emit('closeMerge')" type="button" class="btn btn-outline-secondary">{{ translate('close')
                    }}</button>
                    <div class="col col-8"  v-if="pdfMerging">
                        <span class="text-primary" style="padding-left:20px; display: flex;
                         flex-direction: row; align-items: center; gap: 14px;">
                            <spinner/>
                            {{translate('processingMessages.PDFsMerging')}}
                        </span>
                    </div>
                    <button type="button" class="btn btn-success" :disabled="loading" @click="mergePdfs">{{ translate('draft.mergePdf') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from "../formMixin.js";
import fileUpload from "vue-upload-component"; // https://lian-yue.github.io/vue-upload-component/#/en/documents#getting-started-npm
import iconPlus from '../components/Icons/plus.svg';
import draggable from 'vuedraggable'
import spinner from '@/components/Spinner.vue'
import axios from "axios";
import i18n from "../i18n";
export default {
    mixins: [formMixin],
    components: {
        fileUpload,
        iconPlus,
        draggable,
        spinner
    },
    props: {
        Id: {
            type: String
        }
    },
    created(){
        this.getData('000000000000000000000000', false).then(() => {
            this.data.DraftId = this.Id
        });
    },
    data() {
        return {
            loading: false,
            modelName: 'PdfMerge',
            pdfMerging: false,
            files: [],
            data: {
                Id: "000000000000000000000000",
                Documents: []
            },
        }
    },
    watch: {
        files: function (oldFiles, newFiles) {
            newFiles
                .filter((x) => x && x.response.attachment)
                .forEach((element) => {
                    if (this.data.Documents.filter((d) => d.Id == element.response.attachment.Id).length == 0) {
                        this.data.Documents.push(element.response.attachment);
                        console.log("Documents", this.data.Documents);
                    }
                    this.$refs.pdfUpload.remove(element);
                });
        },
    },
    methods: {
        moveDocumentUp(index) {
            if (index > 0) {
                // Swap the documents in the array
                const temp = this.data.Documents[index];
                this.data.Documents[index] = this.data.Documents[index - 1];
                this.data.Documents[index - 1] = temp;

                // Force a re-render of the component
                this.$forceUpdate();
            }
        },
        moveDocumentDown(index) {
            if (index < this.data.Documents.length - 1) {
                // Swap the documents in the array
                const temp = this.data.Documents[index];
                this.data.Documents[index] = this.data.Documents[index + 1];
                this.data.Documents[index + 1] = temp;

                // Force a re-render of the component
                this.$forceUpdate();
            }
        },
        removeDocument(document) {
            this.loading = true;
            axios.post(`pdfMerge/removeAttachment/${this.data.Id}?filename=${document.FileName}`)
            .then(x => {
                if(x.data.Success) {
                    this.data.Documents = this.data.Documents.filter(x => x != document);
                } else {
                    alert(x.data.ErrorMessages);
                }
            })
            .catch(x => window.processErrorResponse(x, this))
            .then(() => {
                this.loading = false;
            });
        },
        mergePdfs(){
            this.loading = true
            if(this.data.Documents.length <= 1){
                alert(i18n.t('warnings.uploadAtLeastTwoFiles'))
                this.loading = false
            }else{
                this.pdfMerging = true
                const documentIds = this.data.Documents.map(doc => doc.Id);
                const requestData = {
                    Documents: documentIds,
                };
                axios.post(`PdfMerge/CompletePdfMerge/?id=${this.data.Id}`, requestData)
                    .then((response) => {
                        console.log("response", response);
                        if(response.status == 200){
                            this.$emit('success')
                        }
                        this.loading = false;
                        this.pdfMerging = false;
                        
                })
                .catch(x => window.processErrorResponse(x, this))
                .then(() => {
                    this.loading = false;
                    this.pdfMerging = false;
                });
            }
        }
    }
}
</script>

<style scoped>
.documentContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    gap: 10px;
    margin: 5px;
    border-radius: 2px;
}

.documentInner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 5px 0px;
}

.moveIconContainer{
    display: flex;
    flex-direction: row;
    gap: 5px;
}
.moveIconContainer:hover {
    cursor: pointer;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.documentRight{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 20px;
}
</style>